import { get } from 'store/http/httpAction';
import {
  ADD_TEAM_TO_SHARED,
  ADD_USER_TO_SHARED,
  SET_ACTIVE_TEAM,
  SET_SELECTED_USERS,
  SET_SHARABLE_TEAMS,
  SET_SHARABLE_USERS
} from './actionTypes';

export const setSharableUsers = data => ({
  type: SET_SHARABLE_USERS,
  payload: { data }
});

export const tryFetchSharableUsers = () => dispatch =>
  get('/admin/users/all', {}, dispatch).then(data => {
    if (!_.isEmpty(data.data)) {
      dispatch(setSharableUsers(data.data));
    }
  });

export const setSelectedUsers = users => ({
  type: SET_SELECTED_USERS,
  payload: { users }
});

export const setSharableTeams = teams => ({
  type: SET_SHARABLE_TEAMS,
  payload: { teams }
});

export const tryFetchSharableTeams = () => dispatch =>
  get('/admin/teams/struct/info', {}, dispatch).then(data => {
    if (!_.isEmpty(data.teams)) {
      dispatch(setSharableTeams(data.teams));
    }
  });

export const setActiveTeam = teamId => ({
  type: SET_ACTIVE_TEAM,
  payload: { teamId }
});

export const addTeamToShared = team => ({
  type: ADD_TEAM_TO_SHARED,
  payload: { team }
});

export const addUserToShared = user => ({
  type: ADD_USER_TO_SHARED,
  payload: { user }
});



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/flow/actions.js